"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var CardName_1 = require("@/CardName");
var PlayerResource_vue_1 = require("@/client/components/overview/PlayerResource.vue");
var Resources_1 = require("@/Resources");
exports.default = vue_1.default.extend({
    name: 'PlayerResources',
    props: {
        player: {
            type: Object,
        },
    },
    data: function () {
        return {
            resources: Resources_1.Resources,
        };
    },
    methods: {
        canUseHeatAsMegaCredits: function () {
            var _a;
            return ((_a = this.player.corporationCard) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.HELION;
        },
    },
    components: {
        'player-resource': PlayerResource_vue_1.default,
    },
});
